export const formatFromPascalCase = (inputString: string = "") =>
  inputString.split(/(?=[A-Z])/).join(" ");

export const displayName = (firstName = "", surname = "") => {
  const output = [];
  if (firstName) output.push(firstName);
  if (surname) output.push(surname);
  return output.join(" ");
};
